<h4>Edit closing instructions</h4>

<div class="mt-7 mb-3 flex justify-between">
	<app-radio-group
		type="compact"
		label="Payment method"
		[items]="paymentMethods"
		[(ngModel)]="selectedPaymentType"
	></app-radio-group>

	<app-radio-group
		type="compact"
		label="Select split type"
		[items]="splitTypes"
		[(ngModel)]="selectedSplitType"
		(ngModelChange)="changeAmountType($event)"
	></app-radio-group>
</div>

<div
	*ngFor="let clientInstruction of instructions"
	class="flex flex-col mt-3 pb-3 border-b border-grey-veryLight"
>
	<div class="flex flex-col">
		<div class="flex items-center mb-5">
			<div class="flex flex-col justify-center">
				<span class="font-bold">{{ clientInstruction?.name }}</span>
				<div class="relative">
					<span *ngIf="clientInstruction?.estate" class="text-sm absolute"
						>(Estate of)</span
					>
				</div>
			</div>
			<app-anchor
				(click)="goToClientBankingDetails(clientInstruction?.clientId)"
				*ngIf="!clientInstruction?.bankingDetails"
				[@openClose]
				class="ml-3 text-sm text-orange-dark"
				><app-icon class="mr-2" [icon]="ICON.WARNING"></app-icon> Banking
				details are missing</app-anchor
			>
		</div>
		<div class="flex flex-col items-start">
			<div class="flex items-center">
				<app-input
					*ngIf="selectedSplitType === splitType.AMOUNT"
					type="cents"
					[ngModel]="clientInstruction.trustLedgerInstruction.amount"
					textAlign="right"
					(ngModelChange)="amountChanged(clientInstruction, $event)"
				>
				</app-input>
				<app-input
					*ngIf="selectedSplitType === splitType.PERCENTAGE"
					type="number"
					[startIcon]="ICON.PERCENTAGE"
					[ngModel]="
						clientInstruction.trustLedgerInstruction.amount | number: '.0-2'
					"
					textAlign="right"
					(ngModelChange)="amountChanged(clientInstruction, $event)"
				>
				</app-input>
				<div class="flex justify-end text-grey text-sm ml-3">
					<span *ngIf="selectedSplitType === splitType.PERCENTAGE">{{
						clientInstruction?.portionAmount | centsToDollars
					}}</span>
					<span *ngIf="selectedSplitType !== splitType.PERCENTAGE"
						>{{ clientInstruction?.portionPercentage | number: '.0-2' }}%</span
					>
				</div>
			</div>

			<div
				class="mt-3 w-full"
				*ngIf="clientInstruction?.portionPercentage > 0"
				[@openClose]
			>
				<app-text-area
					height="48px"
					[(ngModel)]="clientInstruction.trustLedgerInstruction.description"
					[placeholder]="clientInstruction.defaultDescription"
				></app-text-area>
			</div>
		</div>
	</div>
</div>

<div class="mt-10" *ngIf="showTotalWarning" [@openClose]>
	<atomic-message-bar type="warn"
		>Totals do not match balance from Adjustments</atomic-message-bar
	>
</div>

<div class="flex justify-between items-center mt-10">
	<app-button btn="tertiary" (click)="cancel()" size="small">Cancel</app-button>

	<app-button (click)="save()" size="small" [loading]="saving">Save</app-button>
</div>

<div class="mt-5">
	<atomic-message-bar *ngIf="showTotalError" type="error"
		>Total percentage must equal 100%.</atomic-message-bar
	>
	<atomic-message-bar *ngIf="error" type="error"
		>There was an error saving the instructions. Please try
		again.</atomic-message-bar
	>
</div>
